import React from 'react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

const AboutPage = () => {
  const { t } = useTranslation()

  const companyInfo = [
    { label: t('about.profile.labels.company'), value: 'AlgoMori Inc.' },
    { label: t('about.profile.labels.established'), value: 'November 18, 2025' },
    { label: t('about.profile.labels.address'), value: '12-12, Osaka Ekimae No. 2 Building, 1-2-2 Umeda, Kita-ku, Osaka 530-0001, Japan' },
    { label: t('about.profile.labels.representative'), value: 'Takanori Sato, President & CEO' },
    { label: t('about.profile.labels.capital'), value: 'JPY 5,000,000' },
    { label: t('about.profile.labels.invoice'), value: 'T2120001282152' },
  ]

  return (
    <div className="pt-24 sm:pt-32 pb-24 px-4 sm:px-6 overflow-x-hidden">
      <div className="max-w-5xl mx-auto">
        <nav className="flex items-center gap-1.5 text-xs mb-8 flex-wrap">
          <Link to="/" className="text-text-dim hover:text-primary transition-colors">{t('header.home')}</Link>
          <ChevronRight className="w-3 h-3 text-text-dim/40" />
          <span className="text-text-main font-medium">{t('header.aboutUs', 'About Us')}</span>
        </nav>
        <motion.div className="text-center mb-20" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-display font-bold tracking-tight text-text-main">
            {t('about.title.part1')}<br />
            <span className="text-gradient-green">{t('about.title.part2')}</span>
          </h1>
        </motion.div>

        <motion.div className="bio-card-static p-8 sm:p-12 mb-6" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-xl bg-primary text-white flex items-center justify-center">
              <span className="material-symbols-outlined text-xl">rocket_launch</span>
            </div>
            <h2 className="text-2xl font-display font-bold text-text-main">{t('about.mission.title')}</h2>
          </div>
          <p className="text-text-muted leading-relaxed">
            {t('about.mission.desc')}
          </p>
        </motion.div>

        <motion.div className="bio-card-static p-8 sm:p-12 mb-6" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-xl bg-brand-teal text-white flex items-center justify-center">
              <span className="material-symbols-outlined text-xl">groups</span>
            </div>
            <h2 className="text-2xl font-display font-bold text-text-main">{t('about.team.title')}</h2>
          </div>
          <p className="text-text-muted leading-relaxed">
            {t('about.team.desc')}
          </p>
        </motion.div>

        <motion.div className="bio-card-static p-8 sm:p-12" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 rounded-xl bg-brand-accent text-white flex items-center justify-center">
              <span className="material-symbols-outlined text-xl">domain</span>
            </div>
            <h2 className="text-2xl font-display font-bold text-text-main">{t('about.profile.title')}</h2>
          </div>
          <div className="space-y-0">
            {companyInfo.map((item, i) => (
              <div key={i} className="flex flex-col sm:flex-row sm:items-start py-4 border-b border-border-light last:border-0">
                <span className="text-xs font-semibold text-text-dim uppercase tracking-widest sm:w-80 flex-shrink-0 mb-1 sm:mb-0 sm:pt-0.5">{item.label}</span>
                <span className="text-sm text-text-main break-words min-w-0">
                  {item.value}
                </span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default AboutPage
